export function extractLocationObj(search: string): {
    [key: string]: string
} {
    const result = {}
    for (const [key, value] of new URLSearchParams(String(search)).entries()) {
        result[String(key)] = String(value)
    }    
    return result
}
